import { render, staticRenderFns } from "./TracksTableContentPlaceholder.vue?vue&type=template&id=4c239004&"
import script from "./TracksTableContentPlaceholder.vue?vue&type=script&lang=js&"
export * from "./TracksTableContentPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports